import React from 'react';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';

import { updateHistory } from 'corp/lib/localHistoryStore';
import BaseLayoutUI from './BaseLayoutUI';

const BaseLayoutCore: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  React.useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }
    if (!location.pathname.match(/lookup|search/)) {
      updateHistory({
        id: location.pathname.replace(/^\//, ''),
        query: qs.parse(location.search) as Record<string, string>,
        name: document.title,
        type: 'tool',
      });
    }
  }, [location.pathname, location.search]);

  return <BaseLayoutUI>{children}</BaseLayoutUI>;
};

const BaseLayout = React.memo(BaseLayoutCore);

export default BaseLayout;
